import { Button } from '@bancobarigui/barihaus';
import { Table, Space, Popconfirm, Tag } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

import { ProtectedRouteContainer } from '@/components/ProtectedRouteContainer';
import { PageHeader } from '@/components/PageHeader';
import { ServiceCheck, FeatureAlert } from '@/shared/components';
import { useBankUserList } from './useBankUserList';

function BankUserListContent() {
  const {
    bankUsers,
    loading,
    handleNew,
    handleEdit,
    handleDelete
  } = useBankUserList();

  const tableColumns = [
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Telefone',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
    },
    {
      title: 'Perfis',
      dataIndex: 'roles',
      key: 'roles',
      render: (roles: any[]) => (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
          {roles?.map((role) => (
            <Tag color="blue" key={role.id} style={{ marginInlineEnd: 0 }}>
              {role.name}
            </Tag>
          ))}
        </div>
      ),
    },
    {
      title: 'Tipos de Inspeção',
      dataIndex: 'inspectionTypes',
      key: 'inspectionTypes',
      render: (types: any[]) => (
        <>
          {types?.length || 0} tipo(s)
        </>
      ),
    },
    {
      title: 'Ações',
      key: 'actions',
      width: 200,
      render: (_: any, record: any) => (
        <Space size="small">
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record.userId)}
          >
            Editar
          </Button>
          <Popconfirm
            title="Tem certeza que deseja excluir este usuário?"
            description="Esta ação não pode ser desfeita."
            onConfirm={() => handleDelete(record.userId)}
            okText="Sim, excluir"
            cancelText="Cancelar"
            okButtonProps={{ danger: true }}
          >
            <Button
              type="link"
              danger
              icon={<DeleteOutlined />}
            >
              Excluir
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <ProtectedRouteContainer
      pageHeader={
        <PageHeader
          title="Usuários do Banco"
          actions={
            <Button buttonColor="primary" onClick={handleNew}>
              Cadastrar Novo Usuário
            </Button>
          }
        />
      }
    >
      <FeatureAlert services={['user']} />
      <ServiceCheck services={['user']} featureName="Usuarios do Banco">
        <div className="flex flex-col gap-4">
          <Table
            columns={tableColumns}
            dataSource={bankUsers}
            loading={loading}
            rowKey="userId"
            pagination={{
              defaultPageSize: 10,
              showSizeChanger: true,
              showTotal: (total) => `Total de ${total} usuários`,
            }}
            scroll={{ x: 1000 }}
          />
        </div>
      </ServiceCheck>
    </ProtectedRouteContainer>
  );
}

export function BankUserList() {
  return <BankUserListContent />;
}
